<template>
    <div class="products_page pg_0">
        <Unit 
          v-for="unit in units" 
          :unit="unit"
          :key="unit.code"/>
    </div>
</template>

<script>
import Unit from "./Unit.vue";
const UNIT_DATA_URL = "./products.json";


export default {
    name: "UnitList",
    components: {
        Unit
    },
    data: function() {
        return {
          units : [
    {
        "productId": "8b051a82-e051-11e4-afe5-00259036a192",
        "code": "00000142709",
        "title": "Плитка облицовочная Сан-Ремо 7 200х200х7 мм белая (26 шт=1.04 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, пылевой шпат, кварцевый песок, каолин, красители, фритта.\n\nСтепень блеска: глянцевый.\nКоличество на поддоне: 96 коробок.\nПроизводитель: ОАО «Керамин», Беларусь.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n",
        "primaryImageUrl": "//tdp.ru/images/p/cd9/3ef76-fbad-11e4-afe5-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 13600,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.9615,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 593,
        "priceRetailAlt": 570.1695,
        "priceGold": 576,
        "priceGoldAlt": 553.824,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:58:16"
    },
    {
        "productId": "dded02e3-135e-11e5-b9a9-00259036a192",
        "code": "00000145471",
        "title": "Керамогранит Zula 600х600х10 мм бежевый травертин полированный (4 шт= 1.44 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество на поддоне: 40 коробок.\nПроизводитель: Китай.\n\nСопутствующие: клей для керамогранита; крестики; затирка для швов; плиткорез; крестики для плитки; затирка для швов; плиткорез;\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/dc8/f086d-3073-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для керамогранита; крестики; затирка для швов; плиткорез;; крестики для плитки; затирка для швов; плиткорез;",
        "weight": 33000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.69444,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1336,
        "priceRetailAlt": 927.7718,
        "priceGold": 1283,
        "priceGoldAlt": 890.9665,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-11-02 12:57:00"
    },
    {
        "productId": "5a26045c-0a0c-11e6-bed3-00259036a192",
        "code": "00000156521",
        "title": "Плитка бордюр 400х30 мм Вилланелла белый",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n \nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: глянцевый\nКоличество в упаковке: 22 шт.\nПроизводитель: KERAMA MARAZZI, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/c57/352c8-0a0c-11e6-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 300,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 115,
        "priceRetailAlt": 115,
        "priceGold": 111,
        "priceGoldAlt": 111,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:05:08"
    },
    {
        "productId": "19d7362b-70d6-11e5-9d89-00259036a192",
        "code": "00000148058",
        "title": "Плитка настенная Natali 250х330х7 мм белый (18 шт=1.49 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска:матовая\nКоличество на поддоне: 54 коробки .\nПроизводитель: LASSElSBERGER, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/96f/31ac9-70d6-11e5-9d89-00259036a192.JPG",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 17900,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.67114,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 743,
        "priceRetailAlt": 498.657,
        "priceGold": 714,
        "priceGoldAlt": 479.194,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:53:49"
    },
    {
        "productId": "46751ca7-ecdd-11e4-afe5-00259036a192",
        "code": "00000144103",
        "title": "Плитка облицовочная Мираж 200х300х7 мм верх (24 шт=1.44 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: глянцевый.\nКоличество на поддоне: 54 коробок.\nПроизводитель: ОAО «ВКЗ», Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/19b/1dd48-fbc6-11e4-afe5-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 16490,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.69444,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 409,
        "priceRetailAlt": 284.026,
        "priceGold": 397,
        "priceGoldAlt": 275.6927,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:58:22"
    },
    {
        "productId": "1f2f144c-3fea-11e5-b9a9-00259036a192",
        "code": "00000146668",
        "title": "Плитка декор Relax 250х400х8 мм зеленый №2 494321",
        "description": "ПАННО СОСТОИТ из 4 позиций:\nПлитка декор 250х400х8 мм Релакс зеленый №1 494311\nПлитка декор 250х400х8 мм Релакс зеленый №2 494321\nПлитка декор 250х400х8 мм Релакс зеленый №3 494331\nПлитка декор 250х400х8 мм Релакс зеленый №4 494341\n\nПредназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: глянцевая\nКоличество в упаковке: 6 шт.\nПроизводитель: GOLDEN TILE, Украина\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/cbb/ed1f4-8eb9-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 1430,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 627,
        "priceRetailAlt": 627,
        "priceGold": 609,
        "priceGoldAlt": 609,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:32"
    },
    {
        "productId": "3236fe2d-09fe-11e6-bed3-00259036a192",
        "code": "00000156497",
        "title": "Плитка напольная 402х402х8,3 мм Уайтхолл черный (10 шт=1,62 кв.м)",
        "description": "Предназначена для отделки пола в ванной комнате, санузлах, кухне и в других внутренних помещениях.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: Матовая\nКоличество на поддоне:  48 коробок\nПроизводитель: KERAMA MARAZZI, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/fdb/98c28-5a3e-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 30500,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.6172,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1197,
        "priceRetailAlt": 738.7884,
        "priceGold": 1149,
        "priceGoldAlt": 709.1628,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:04:42"
    },
    {
        "productId": "da280b42-a23c-11e5-bed3-00259036a192",
        "code": "00000152640",
        "title": "Плитка облицовочная 200х300х7 мм Каррара светло-палевая ЛАЙТ (18 шт = 1,08 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\nРисунок на плитку нанесен методом цифровой печати., ее главное отличие отсутствие белого канта по периметру плитки.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nКоличество на поддоне: 80 коробок.\nПроизводитель: ЕВРО-КЕРАМИКА, Россия.\n\nСопутствующие: клей для плитки, клинья для кафеля, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/e20/1df2f-a895-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nклинья для кафеля;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 13300,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.92592,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 230,
        "priceRetailAlt": 212.9616,
        "priceGold": 230,
        "priceGoldAlt": 212.9616,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:23"
    },
    {
        "productId": "8fe199c5-2710-11e5-b9a9-00259036a192",
        "code": "00000146176",
        "title": "Плитка декор Vesta D1 200х300х7 мм бежевый с золотом",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество в коробке: 19 шт.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/6c2/8d004-e5cb-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 680,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 169,
        "priceRetailAlt": 169,
        "priceGold": 164,
        "priceGoldAlt": 164,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:15"
    },
    {
        "productId": "feed631e-c1a0-11e4-afe5-00259036a192",
        "code": "00000140628",
        "title": "Газобетон 375х250х625 мм D400 Ytong",
        "description": "Газобетон - ячеистый бетон автоклавного твердения.\nПредназначен для возведения перегородок в малоэтажном строительстве, в высотном строительстве газобетонные блоки применяются при монолитно-каркасном строительстве зданий.\nГазобетонные блоки толщиной от 50 до 150  мм  используются для возведения перегородок, блоки толщиной 200 мм и 250 мм  - для возведения наружных стен зданий с сезонным проживанием с весны по осень, блоки толщиной 300 мм, 375 мм и 400 мм для возведения наружных стен зданий с круглогодичным проживанием. \n\nСостав: цемент, кварцевый песок, известь, вода.\n\nТорцевая поверхность: плоская, без карманов.\nКоличество на поддоне: 24 шт (1,406 м.куб.).\nКоличество (вместимость) поддонов в машине: машина 20т - 27 поддонов (648 шт.).\nВ 1 м.куб.: 17 шт.\nПроизводитель: Московская область, Можайский район, пос. Строитель.\n\nТехнические характеристики:\nСредняя плотность: 400 кг/м.куб.\nКласс по прочности: В 2,5 (3,4Мпа, 35 кг/см2).\nМорозостойкость: F100.\n\nСопутствующие: \nклей для газобетона, ножовка по газобетону, угольник для резки газобетона, штроборез по газобетону, кельма-ковш  для газобетона, уровень, рулетка.\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/097/bcfa8-921f-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для газобетона;\nножовка по газобетону;\nугольник для резки газобетона;\nштроборез по газобетону;\nкельма-ковш для газобетона;\nуровень;\nрулетка;",
        "weight": 39500,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 252,
        "priceRetailAlt": 252,
        "priceGold": 252,
        "priceGoldAlt": 252,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 12:27:16"
    },
    {
        "productId": "96f03300-9fcd-11e5-bed3-00259036a192",
        "code": "00000152464",
        "title": "Линолеум полукоммерческий Tarkett Sprint Pro Baden 1 3.5 м",
        "description": "Полукоммерческий линолеум можно настилать в помещениях с нормальной или умеренно высокой проходимостью.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 23 м/п (80,5 кв.м.).\nСтрана производства: Россия.\n\nТехнические характеристики:\nОбщая толщина: 1,8 мм.\nТолщина защитного слоя: 0,4 мм.\nКласс покрытия по области применения: 32.\n\nСопутствующие: рулетка, нож, лента малярная, порожки, клей, плинтус.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/0f8/278a0-9fce-11e5-bed3-00259036a192.jpg",
        "assocProducts": "рулетка;\nнож;\nлента малярная;\nпорожки;\nклей для линолеума холодная сварка;\nклей для напольных покрытий;\nплинтус натуральный;",
        "weight": 9450,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.28571,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1713,
        "priceRetailAlt": 489.4212,
        "priceGold": 1663,
        "priceGoldAlt": 475.1357,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:02:00"
    },
    {
        "productId": "a46388e8-399e-11df-8e55-0023543d7b52",
        "code": "00000106144",
        "title": "Плитка тротуарная 8-кирпичей 400х400х50 мм серая",
        "description": "Предназначена для мощения пешеходных зон, террас, дорожек. \nНа поверхности тротуарной плитки не образуются лужи, так как вода свободно уходит через зазоры, заполненные песком, при необходимости проведения ремонтных работ (например, прокладка подземных коммуникаций) тротуарную плитку можно легко снять, провести необходимые работы и уложить снова, в летнее время нагрев покрытия из плитки значительно меньше, чем нагрев асфальта, при этом плиточное покрытие не размягчается и не выделяет летучих продуктов.\n\nСостав: цемент, песок, химические добавки.\n\nКоличество на поддоне: 96 шт. \nКоличество в 1м.кв.: 6,2 шт.\nПроизводитель: Россия.\n\nТехнические характеристики:\nПрочность на сжатие, класс: не ниже В 22.5.\nМорозостойкость: F200.\nВодопоглощение по массе: не более 6 %.\nДопустимое отклонение геометрических параметров по толщине ±6%\n\nСопутствующие: песок строительный, щебень фр.5-20, Мегаизол ГЕО или Наноизол ГЕО, уровень, резиновая киянка, лопата.\n",
        "primaryImageUrl": "//tdp.ru/images/p/da4/4a465-b9b7-11df-9b7f-001f29c68b0a.jpg",
        "assocProducts": "песок строительный;\nщебень фр.5-20;\nгеотекстиль;\nуровень;\nрезиновая киянка;\nлопата;",
        "weight": 17500,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 6.25,
        "unitFullAlt": "",
        "priceRetail": 115,
        "priceRetailAlt": 718.75,
        "priceGold": 110,
        "priceGoldAlt": 687.5,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:25:26"
    },
    {
        "productId": "7eb373e5-50bd-11e5-b9a9-00259036a192",
        "code": "00000147220",
        "title": "Плитка облицовочная Еврокерамика 200х200х7 мм моноколор бежевая 22 шт 0.88 кв.м.",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений. \n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\nСтепень блеска: матовый.\n\nКоличество на поддоне: 104 коробки.\nПроизводитель: ЕВРО-КЕРАМИКА,  Россия.\n\n\nСопутствующие: клей для плитки, крестики , затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/80b/cc21a-56d7-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка;\nплиткорез;",
        "weight": 10840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 1.13637,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 266,
        "priceRetailAlt": 302.2744,
        "priceGold": 259,
        "priceGoldAlt": 294.3198,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:18"
    },
    {
        "productId": "ace50ec2-29ec-11e5-b9a9-00259036a192",
        "code": "00000146224",
        "title": "Плитка напольная Dorian 327х327х8 мм коричневый (13 шт=1.39 кв.м)",
        "description": "Тон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: \nКоличество на поддоне: 46 упак. \nПроизводитель: : ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/dc1/2a623-308e-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 23900,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.71942,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 741,
        "priceRetailAlt": 533.0902,
        "priceGold": 718,
        "priceGoldAlt": 516.5436,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:17"
    },
    {
        "productId": "48561e45-5192-11e5-b9a9-00259036a192",
        "code": "00000147273",
        "title": "Ламинат 32 кл Kronospan Castello Дуб Пастельный 2,22 м.кв. 8 мм",
        "description": "Предназначен для использования в жилых помещениях с любой проходимостью и в коммерческих помещениях со средней степенью проходимости: гостинные комнаты, коридоры, небольшие офисы, торговые площади небольших магазинов и др.\n\nСостав: панель ХДФ (древесноволокнистая плита высокой плотности), декоративный и защитные слои.\n\nРазмер панели: 1285х192х8 мм.\nКоличество в упаковке: 9 шт. \nПроизводитель: Беларусь.\nЗамковая система: TwinClic\n\nСопутствующие: подложка, плинтус, рулетка, набор для укладки ламината, ножовка по ламинату 500 мм Bahco Профи, гель для стыков ламината Clic Protect, теплый пол комплект Thermomat LP под ламинат и паркет.",
        "primaryImageUrl": "//tdp.ru/images/p/6ea/eceee-52f2-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "подложка;\nплинтус натуральный;\nрулетка;\nнабор для укладки ламината;\nножовка по ламинату;\nгель для стыков ламината Clic Protect;\nтеплый пол комплект Thermomat LP под ламинат и паркет;",
        "weight": 15000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.45045,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 994,
        "priceRetailAlt": 447.7473,
        "priceGold": 955,
        "priceGoldAlt": 430.1798,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:41:17"
    },
    {
        "productId": "46a2a91a-8f4e-11e5-bed3-00259036a192",
        "code": "00000150081",
        "title": "Керамогранит LB-ceramist Орнелла 300х300х7 мм фон коричневый (15 шт.=1.35 кв.м)",
        "description": "Предназначена для облицовки пола, внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \nСтепень блеска: глянцевый.\n\nКоличество на поддоне: 48 коробок.\nПроизводитель: Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/9c9/b925a-8f4e-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 20000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.74074,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 760,
        "priceRetailAlt": 562.9624,
        "priceGold": 738,
        "priceGoldAlt": 546.6661,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 13:15:52"
    },
    {
        "productId": "c7e2c82d-4748-11e5-b9a9-00259036a192",
        "code": "00000146933",
        "title": "Керамогранит декор 70х70х9 мм Linen светло-бежевый/Грасаро",
        "description": "Предназначен для использования в качестве декоративного элемента, применение которого позволяет украсить поверхность.\n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество в коробке: 40 шт.\nПроизводитель: GRASARO, Россия.\n\nТехнические характеристики:\nКласс износостойкости (PEI): 3-4.\nМорозостойкость: не менее F 150.\n\nСопутствующие: клей для керамогранита, крестики, затирка для швов, плиткорез, крестики для плитки, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/23b/f9ffd-8956-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;\nкрестики для плитки;\nзатирка для швов;\nплиткорез;",
        "weight": 100,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 89,
        "priceRetailAlt": 89,
        "priceGold": 85,
        "priceGoldAlt": 85,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:55"
    },
    {
        "productId": "91047c34-2959-11e5-b9a9-00259036a192",
        "code": "00000146208",
        "title": "Плитка облицовочная ВКЗ 250х350х7 мм белая (18 шт=1.58 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \nСтепень блеска: глянцевый.\n\nКоличество на поддоне: 54 коробки.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/afe/eb581-308f-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 19360,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.63291,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 390,
        "priceRetailAlt": 246.8349,
        "priceGold": 378,
        "priceGoldAlt": 239.24,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:16"
    },
    {
        "productId": "f8fc1777-bdbd-11e4-afe5-00259036a192",
        "code": "00000140481",
        "title": "Керамогранит Керамин Мадейра 4-2 500х500х9 мм коричневый (5 шт=1.25 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество на поддоне: 30 коробок.\nПроизводитель: КЕРАМИН, Беларусь. \n\nТехнические характеристики:\nКласс износостойкости (PEI): ≥ 2.\nМорозостойкость: не менее F 50.\n\nСопутствующие: специальные клеевые смеси для керамогранита (Крепс усиленный, Вебер.Ветонит Профи, Вебер.Ветонит Ультра Фикс, Флизен, Плитонит В+), крестики для плитки, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/f48/b0480-bdbe-11e4-afe5-00259036a192.jpg",
        "assocProducts": "",
        "weight": 25350,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.8,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1016,
        "priceRetailAlt": 812.8,
        "priceGold": 984,
        "priceGoldAlt": 787.2,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:55:27"
    },
    {
        "productId": "d29312af-edb0-11e4-afe5-00259036a192",
        "code": "00000144489",
        "title": "Линолеум полукоммерческий Juteks Respect Dalton 1002 4 м",
        "description": "Полукоммерческий гетерогенный (многослойный) линолеум.\nПредназначен для использования в общественных помещениях с высокими эксплуатационными нагрузками: в магазинах, школах, больших офисах, больницах. Обладает устойчивостью к воздействию мебели на роликовых ножках. Имеет защитный слой, защищающий покрытие от проникновения грязи внутрь и облегчающий уход за ним.\n\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: стеклохолст, поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 27 м/п.\nПроизводитель: Россия.\n\nТехнические характеристики:\nОбщая толщина: 2,2 мм.\nТолщина защитного слоя: 0,4 мм.\nКласс покрытия по области применения: 32.\n\nСопутствующие: рулетка, нож, клей Thomsit, клей хол. сварка Sintex H-44, лента малярная, порожки.\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/6d7/84f82-fa57-11e4-afe5-00259036a192.jpg",
        "assocProducts": "рулетка;\nнож;\nклей Thomsit;\nклей для линолеума;\nклей для напольных покрытий;\nлента малярная;\nпорожки;",
        "weight": 8000,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.25,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1807,
        "priceRetailAlt": 451.75,
        "priceGold": 1734,
        "priceGoldAlt": 433.5,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:58:38"
    },
    {
        "productId": "08e0ba92-3f59-11e5-b9a9-00259036a192",
        "code": "00000146657",
        "title": "Плитка напольная Relax 400х400х8 мм зеленый (7 шт=1.12 кв.м)",
        "description": "Предназначена для отделки пола в ванной комнате, санузлах, кухне и в других внутренних помещениях.\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевая\n\nКоличество на поддоне:72 упаковки.\n Производитель: GOLDEN TILE, Украина\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/3aa/a4454-8eba-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 19840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.89286,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1029,
        "priceRetailAlt": 918.7529,
        "priceGold": 998,
        "priceGoldAlt": 891.0743,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:28"
    },
    {
        "productId": "5db2bae4-3ffd-11e5-b9a9-00259036a192",
        "code": "00000146717",
        "title": "Плитка напольная Bali 400х400х7 мм коричневый (7шт=1.12 кв.м)",
        "description": "Предназначена для отделки пола в ванной комнате, санузлах, кухне и в других внутренних помещениях.\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевая\n\nКоличество на поддоне:72 упаковки.\n Производитель: GOLDEN TILE, Украина \n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/ef5/0928d-8170-11e5-9d89-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 19840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.89286,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 961,
        "priceRetailAlt": 858.0385,
        "priceGold": 932,
        "priceGoldAlt": 832.1455,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:41"
    },
    {
        "productId": "32e49ea2-0d47-11e6-bed3-00259036a192",
        "code": "00000156835",
        "title": "Плитка облицовочная 275х400х7,5 мм Лаура 4С зеленый  (15 шт= 1,65 кв.м)",
        "description": "Предназначена для использования в качестве внутренней облицовки стен\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевый\nКоличество на поддоне: 36 коробок\nПроизводитель: КЕРАМИН, Беларусь. \n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/96a/2bdd9-2ee8-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 20900,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.606,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1105,
        "priceRetailAlt": 669.63,
        "priceGold": 1070.85,
        "priceGoldAlt": 648.9351,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:06:35"
    },
    {
        "productId": "bc24346c-95af-11e5-bed3-00259036a192",
        "code": "00000151267",
        "title": "Керамогранит Kerama Marazzi Гилфорд 300х300х8 мм темно-серый (16 шт=1.44 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др \n\nТон (оттенок) может отличаться от партии к партии.\nКалибр может отличаться от партии к партии\n\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: Матовый\nКоличество на поддоне: 40 коробок\nПроизводитель: KERAMA MARAZZI, Россия\nКласс износостойкости (PEI): 3\nМорозостойкость: >120\n\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/fd6/f2bac-95af-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки; крестики; затирка для швов; плиткорез;",
        "weight": 26160,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.6944,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 711,
        "priceRetailAlt": 493.7184,
        "priceGold": 690,
        "priceGoldAlt": 479.136,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-11-02 18:00:50"
    },
    {
        "productId": "a46388e8-399e-11df-8e55-0023543d7b52",
        "code": "00000106144",
        "title": "Плитка тротуарная 8-кирпичей 400х400х50 мм серая",
        "description": "Предназначена для мощения пешеходных зон, террас, дорожек. \nНа поверхности тротуарной плитки не образуются лужи, так как вода свободно уходит через зазоры, заполненные песком, при необходимости проведения ремонтных работ (например, прокладка подземных коммуникаций) тротуарную плитку можно легко снять, провести необходимые работы и уложить снова, в летнее время нагрев покрытия из плитки значительно меньше, чем нагрев асфальта, при этом плиточное покрытие не размягчается и не выделяет летучих продуктов.\n\nСостав: цемент, песок, химические добавки.\n\nКоличество на поддоне: 96 шт. \nКоличество в 1м.кв.: 6,2 шт.\nПроизводитель: Россия.\n\nТехнические характеристики:\nПрочность на сжатие, класс: не ниже В 22.5.\nМорозостойкость: F200.\nВодопоглощение по массе: не более 6 %.\nДопустимое отклонение геометрических параметров по толщине ±6%\n\nСопутствующие: песок строительный, щебень фр.5-20, Мегаизол ГЕО или Наноизол ГЕО, уровень, резиновая киянка, лопата.\n",
        "primaryImageUrl": "//tdp.ru/images/p/da4/4a465-b9b7-11df-9b7f-001f29c68b0a.jpg",
        "assocProducts": "песок строительный;\nщебень фр.5-20;\nгеотекстиль;\nуровень;\nрезиновая киянка;\nлопата;",
        "weight": 17500,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 6.25,
        "unitFullAlt": "",
        "priceRetail": 118,
        "priceRetailAlt": 737.5,
        "priceGold": 114,
        "priceGoldAlt": 712.5,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:25:26"
    },
    {
        "productId": "2c9196a2-09ef-11e6-bed3-00259036a192",
        "code": "00000156482",
        "title": "Плитка декор 250х600х9 мм Богемия коричневый 02",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевый\nКоличество в упаковке: 6 шт \nПроизводитель: ШАХТЫ, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/985/70ed5-20eb-11e6-95f7-00259036a192.png",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 2570,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 439,
        "priceRetailAlt": 439,
        "priceGold": 425,
        "priceGoldAlt": 425,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:50"
    },
    {
        "productId": "ffc00a10-4d6a-11e4-a9cf-002590c8c920",
        "code": "00000137668",
        "title": "Плитка облицовочная Гламур 2С 400х275х7.5 мм микс (15 шт = 1.65 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество на поддоне: 36 коробок.\nПроизводитель: КЕРАМИН, Беларусь.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/814/3adb2-5367-11e4-a9cf-002590c8c920.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез.;",
        "weight": 21470,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.60606,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1085,
        "priceRetailAlt": 657.5751,
        "priceGold": 1053,
        "priceGoldAlt": 638.1812,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:55:15"
    },
    {
        "productId": "2dfba75e-9f28-11e5-bed3-00259036a192",
        "code": "00000152355",
        "title": "Линолеум бытовой Tarkett Grand Aston 1 3 м",
        "description": "Предназначен для использования в жилых помещениях с средними эксплуатационными нагрузками, например: гостиная, детская комната.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 20 м/п (60 кв.м.).\nСтрана производства: Россия.\n\nТехнические характеристики:\nОбщая толщина: 4,5 мм.\nТолщина защитного слоя: 0,3 мм.\nКласс покрытия по области применения: 23/31.\n\nСопутствующие: рулетка, нож, лента малярная, порожки, клей, плинтус.\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/8cf/be7c0-9f28-11e5-bed3-00259036a192.jpg",
        "assocProducts": "рулетка;\nнож;\nлента малярная;\nпорожки;\nклей для линолеума холодная сварка;\nклей для напольных покрытий;\nплинтус темный;",
        "weight": 9900,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.33333,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1897,
        "priceRetailAlt": 632.327,
        "priceGold": 1842,
        "priceGoldAlt": 613.9939,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 13:28:12"
    },
    {
        "productId": "93107bab-177f-11e6-b7ce-00259036a192",
        "code": "00000157341",
        "title": "Линолеум бытовой 1,5 м Синтерос (Tarkett) Vesna Toronto 1",
        "description": "Бытовой гетерогенный (многослойный) линолеум.\nПредназначен для использования в жилых помещениях с средними эксплуатационными нагрузками, например: гостиная, детская комната.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: стеклохолст, поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 30 м/п.\nПроизводитель: Россия\n\nТехнические характеристики:\nОбщая толщина: 2,8 мм.\nТолщина защитного слоя: 0,15 мм.\nКласс покрытия по области применения: 21.\nКласс пожарной опасности: КМ 5\n\nСопутствующие: рулетка, нож, клей Thomsit, клей хол. сварка Sintex H-44, лента малярная, порожки.малярная, порожки.\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/017/e3f52-54da-11e6-95f7-00259036a192.jpg",
        "assocProducts": "рулетка;\nнож;\nклей Thomsit;\nклей для напольных покрытий;\nлента малярная;\nпорожки;",
        "weight": 1820,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.66666,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 462,
        "priceRetailAlt": 307.9969,
        "priceGold": 443,
        "priceGoldAlt": 295.3304,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:58:58"
    },
    {
        "productId": "87440b19-ecdf-11e5-bed3-00259036a192",
        "code": "00000155248",
        "title": "Плитка облицовочная 200х300х7 мм Травертин бежевый Люкс (24шт=1,44 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \nСтепень блеска: матовый.\n\nКоличество на поддоне: 54 коробки.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/bf1/a2bf9-ecdf-11e5-bed3-00259036a192.tif",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 16490,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "упак.",
        "unitRatioAlt": 1,
        "unitFullAlt": "упаковка",
        "priceRetail": 503,
        "priceRetailAlt": 503,
        "priceGold": 487,
        "priceGoldAlt": 487,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:27"
    },
    {
        "productId": "80793868-a7c0-11e5-bed3-00259036a192",
        "code": "00000153178",
        "title": "Ламинат Loc Floor 82 дуб шоколадный 33 кл 8 мм 1.596 кв.м",
        "description": "Предназначен для использования в жилых помещениях с любой проходимостью и в коммерческих помещениях со средней степенью проходимости: гостиные комнаты, коридоры, небольшие офисы, торговые площади небольших магазинов и др.\n\nСостав: Состав: панель ХДФ (древесноволокнистая плита высокой плотности) с усиленной защитой от влаги, декоративный и защитные слои.\n\nРазмер панели: 1200х190х8мм.\nКоличество в упаковке: 7 шт. \nПроизводитель: Россия.\n\nСопутствующие: подложка, рулетка, набор для укладки ламината, лобзик, плинтус, теплый пол под ламинат и паркет.\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/0e9/d2caf-d4bd-11e5-bed3-00259036a192.jpg",
        "assocProducts": "подложка;\nрулетка;\nнабор для укладки ламината;\nлобзик;\nплинтус темный;\nтеплый пол под ламинат и паркет;",
        "weight": 12370,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.62657,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1337,
        "priceRetailAlt": 837.7241,
        "priceGold": 1298,
        "priceGoldAlt": 813.2878,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:32:57"
    },
    {
        "productId": "fd21ef21-50c0-11e5-b9a9-00259036a192",
        "code": "00000147224",
        "title": "Плитка облицовочная ЕвроКерамика 200х200х7 мм моноколор желтый (22 шт=0.88 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений. \n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\nСтепень блеска: матовый.\n\nКоличество на поддоне: 104 коробки.\nПроизводитель: ЕВРО-КЕРАМИКА,  Россия.\n\n\nСопутствующие: клей для плитки, крестики , затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/a76/8983c-56d7-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка;\nплиткорез;",
        "weight": 10840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 1.13637,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 373,
        "priceRetailAlt": 423.866,
        "priceGold": 363,
        "priceGoldAlt": 412.5023,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:18"
    },
    {
        "productId": "c7b4f706-0072-11e6-bed3-00259036a192",
        "code": "00000155785",
        "title": "Керамогранит декор 450х450х9 мм Энигма натуральный/LB",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\nСтепень блеска:матовая\n\nКоличество в упаковке: 6 шт.\nПроизводитель: LASSElSBERGER, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/ad1/8b846-0073-11e6-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 4080,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 399,
        "priceRetailAlt": 399,
        "priceGold": 383,
        "priceGoldAlt": 383,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:02:53"
    },
    {
        "productId": "d7d55d07-9530-11e5-bed3-00259036a192",
        "code": "00000151199",
        "title": "Мозаика из стекломассы 327х327х4 мм песочный микс на сетке (10 шт=1.07 кв.м)",
        "description": "Предназначена для внутренних и внешних работ, включая отделки фонтанов, бассейнов, саун и ванных комнат.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: кварцевый песок (SiO2) , около 90 % и оксид кальция(СаО2) - около 6 %, примеси. \nСтепень блеска: матовый.\n\nКоличество на поддоне: 114 коробок.\nПроизводитель: Китай.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n",
        "primaryImageUrl": "//tdp.ru/images/p/e3f/ee387-9530-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 6540,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.93458,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1148,
        "priceRetailAlt": 1072.8979,
        "priceGold": 1115,
        "priceGoldAlt": 1042.0567,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 13:22:22"
    },
    {
        "productId": "8042fc6b-1c1e-11e6-b7ce-00259036a192",
        "code": "00000157525",
        "title": "Газобетон 400 625х250х400 мм D500 AeroStonе",
        "description": "Газобетон - ячеистый бетон автоклавного твердения.\nПредназначен для возведения перегородок в малоэтажном строительстве, в высотном строительстве газобетонные блоки применяются при монолитно-каркасном строительстве зданий.\nГазобетонные блоки толщиной от 50 до 150  мм  используются для возведения перегородок, блоки толщиной 200 мм и 250 мм  - для возведения наружных стен зданий с сезонным проживанием с весны по осень, блоки толщиной 300 мм, 375 мм и 400 мм для возведения наружных стен зданий с круглогодичным проживанием.\n\nСостав: цемент, кварцевый песок, известь, вода.\n\nТорцевая поверхность: плоские грани\nКоличество на поддоне: 24 шт. (1,5 м.куб.).\nКоличество (вместимость) поддонов в машине: машина 20 т – 20  поддонов (30м3) (480 шт.).\nВ 1 м.куб.: 16 шт.\nПроизводитель: д. Селёвкино, Дмитровского р-на Московской области.\n\nТехнические характеристики:\nСредняя плотность: 500 кг/м.куб.\nКласс по прочности: В 3,5- 5,0 (35-50 кг/см2).\nМорозостойкость: F100\n\nСопутствующие: клей для газобетона, ножовка по газобетону, угольник для резки газобетона, штроборез по газобетону, уровень, рулетка.\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/04b/3da60-1da2-11e6-b7ce-00259036a192.jpg",
        "assocProducts": "клей для газобетона;\nножовка по газобетону;\nугольник для резки газобетона;\nштроборез по газобетону;\nуровень;\nрулетка;",
        "weight": 44850,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "м.куб.",
        "unitRatioAlt": 16,
        "unitFullAlt": "Метр кубический",
        "priceRetail": 235,
        "priceRetailAlt": 3760,
        "priceGold": 235,
        "priceGoldAlt": 3760,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:16:57"
    },
    {
        "productId": "3c520128-70d7-11e5-9d89-00259036a192",
        "code": "00000148061",
        "title": "Плитка настенная Natali 250х330х7 мм розовый (18 шт=1.49 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска:матовая\nКоличество на поддоне: 54 коробки .\nПроизводитель: LASSElSBERGER, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/ba1/2230d-70d7-11e5-9d89-00259036a192.JPG",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 17900,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.67114,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 743,
        "priceRetailAlt": 498.657,
        "priceGold": 723,
        "priceGoldAlt": 485.2342,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:53:52"
    },
    {
        "productId": "c18abe5c-d8fe-11e4-afe5-00259036a192",
        "code": "00000142243",
        "title": "Линолеум бытовой 3 м Juteks Venus Taco 2314",
        "description": "Бытовой гетерогенный (многослойный) линолеум.\nПредназначен для использования в жилых помещениях с средними эксплуатационными нагрузками, например: гостиная, детская комната.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: стеклохолст, поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 18-30 м/п.\nПроизводитель: Россия\n\nТехнические характеристики:\nОбщая толщина: 2,7 мм.\nТолщина защитного слоя: 0,15 мм.\nКласс покрытия по области применения: 22.\n\nСопутствующие: рулетка, нож, клей Thomsit, клей хол. сварка Sintex H-44, лента малярная, порожки.\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/525/cc7a4-feea-11e4-afe5-00259036a192.jpg",
        "assocProducts": "рулетка;\nнож;\nклей Thomsit;\nклей для линолеума;\nклей для напольных покрытий;\nлента малярная;\nпорожк;",
        "weight": 4350,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.33333,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1093,
        "priceRetailAlt": 364.3297,
        "priceGold": 1050,
        "priceGoldAlt": 349.9965,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:57:46"
    },
    {
        "productId": "a0366edc-fb36-11e5-bed3-00259036a192",
        "code": "00000155611",
        "title": "Плитка напольная Light 326х326х8,3 мм бежевая  (11шт=1,17 кв.м)",
        "description": "Предназначена для отделки пола в ванной комнате, санузлах, кухне и в других внутренних помещениях.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество на поддоне: 48 коробок.\nПроизводитель:CERSANIT, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n",
        "primaryImageUrl": "//tdp.ru/images/p/198/394f2-0582-11e6-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 20270,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.8547,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 312,
        "priceRetailAlt": 266.6664,
        "priceGold": 302,
        "priceGoldAlt": 258.1194,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:02:48"
    },
    {
        "productId": "6023a952-f416-11e2-8c9a-00259036a114",
        "code": "00000130806",
        "title": "Керамогранит Zula 600х600х10 мм бежево-серый полированный (4 шт = 1.44 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с высокой проходимостью, а также для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) могут отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: глянцевый.\nКоличество на поддоне: 40 коробок.\nПроизводитель: Китай\n\nТехнические характеристики:\nМорозостойкость: F 150.\n\nСопутствующие товары: клей для керамогранита; крестики; затирка для швов; плиткорез; крестики для плитки; затирка для швов; плиткорез;\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/99e/5e71c-f99f-11e2-8c9a-00259036a114.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;\nкрестики для плитки;\nклинья для плитки;\nзатирка для швов;\nплиткорез;",
        "weight": 34000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 0.69444,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1080,
        "priceRetailAlt": 749.9952,
        "priceGold": 1048,
        "priceGoldAlt": 727.7731,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-25 11:47:31"
    },
    {
        "productId": "9aa7fd4c-d904-11e4-afe5-00259036a192",
        "code": "00000142254",
        "title": "Линолеум бытовой 3 м Juteks Trend Tara 3187",
        "description": "Бытовой гетерогенный (многослойный) линолеум.\nПредназначен для использования в жилых помещениях с средними эксплуатационными нагрузками, например: гостиная, детская комната.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: стеклохолст, поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 18-33 м/п.\nПроизводитель: Россия\n\nТехнические характеристики:\nОбщая толщина: 2,4 мм.\nТолщина защитного слоя: 0,15 мм.\nКласс покрытия по области применения: 22.\n\nСопутствующие: рулетка, нож, клей Thomsit, клей хол. сварка Sintex H-44, лента малярная, порожки.\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/66d/72d49-fee8-11e4-afe5-00259036a192.jpg",
        "assocProducts": "рулетка;\nнож;\nклей Thomsit;\nклей для линолеума;\nклей для напольных покрытий;\nлента малярная;\nпорожк;",
        "weight": 3750,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.33333,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 763,
        "priceRetailAlt": 254.3308,
        "priceGold": 741,
        "priceGoldAlt": 246.9975,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 13:41:22"
    },
    {
        "productId": "9544cd98-ef6b-11e5-bed3-00259036a192",
        "code": "00000155307",
        "title": "Мозаика 305х305х8 мм М0006 светло-зеленый микс на сетке/ЕвроКерамика (11 шт=1 кв.м.)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений. \n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nКоличество на поддоне: 56 коробок.\nПроизводитель: ЕВРО-КЕРАМИКА,  Россия.\n\nСопутствующие: клей для плитки, крестики , затирка для швов, плиткорез.\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/781/90f8c-1c2d-11e6-b7ce-00259036a192.png",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 14900,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 1,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 749,
        "priceRetailAlt": 749,
        "priceGold": 726,
        "priceGoldAlt": 726,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:02:45"
    },
    {
        "productId": "3ff6051b-4cb6-11e6-95f7-00259036a192",
        "code": "00000159233",
        "title": "Мозаика из стекломассы 327x327х4 мм Lavelly Wave/Волна (20 шт = 2,139 кв.м)",
        "description": "Предназначена для облицовки жилых (кухня, ванная комната, туалет и пр.), коммерческих (магазин, кафе, отель, фитнес-центр) помещений, бассейнов частных и общественных. Отличается высокой прочностью, морозостойкостью, износостойкостью, жаропрочностью, водонепроницаемостью и длительным сроком службы.\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: стекломасса\n\nРазмер листа 327х327х4 мм; размер ячейки 20х20х4 мм..\n\nСтепень блеска: глянцевый\nКоличество в упаковке: 20 шт.\nПроизводитель: Китай\n\nСопутствующие: клей для мозаики, затирка для швов, стеклорез, нож.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/417/7068f-4f3e-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 13500,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.4675,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1390,
        "priceRetailAlt": 649.825,
        "priceGold": 1349,
        "priceGoldAlt": 630.6575,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:26:58"
    },
    {
        "productId": "e4f7088f-4746-11e5-b9a9-00259036a192",
        "code": "00000146926",
        "title": "Керамогранит декор 400x400х9 мм Svalbard темно-коричневый/Грасаро",
        "description": "Предназначен для использования в качестве декоративного элемента, применение которого позволяет украсить поверхность.\n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество в коробке: 8 шт.\nПроизводитель: GRASARO, Россия.\n\nТехнические характеристики:\nКласс износостойкости (PEI): 3-4.\nМорозостойкость: не менее F 150.\n\nСопутствующие: клей для керамогранита, крестики, затирка для швов, плиткорез, крестики для плитки, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/40a/7115e-8953-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;\nкрестики для плитки;\nзатирка для швов;\nплиткорез;",
        "weight": 3160,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 213,
        "priceRetailAlt": 213,
        "priceGold": 207,
        "priceGoldAlt": 207,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:18"
    },
    {
        "productId": "cc253738-ef4a-11e5-bed3-00259036a192",
        "code": "00000155288",
        "title": "Плитка напольная 420x420х9 мм Иллюжн  (8 шт = 1,41 кв.м)",
        "description": "Предназначена для отделки пола в ванной комнате, санузлах, кухне и в других внутренних помещениях.\n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nКоличество на поддоне: 24 коробки.\nПроизводитель:CERSANIT, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез. \n",
        "primaryImageUrl": "//tdp.ru/images/p/92b/e09d6-f65a-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки; крестики; затирка для швов; плиткорез;",
        "weight": 27600,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.70922,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1023,
        "priceRetailAlt": 725.5321,
        "priceGold": 992,
        "priceGoldAlt": 703.5462,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-11-02 17:46:31"
    },
    {
        "productId": "eccff5fb-af36-11e2-99f1-00259036a114",
        "code": "00000129410",
        "title": "Линолеум коммерческий 3 м IVC Concept Samson 635",
        "description": "Коммерческий гетерогенный (многослойный) линолеум с полиуретановым защитным слоем.\nПредназначен для использования в коммерческих помещениях с высокими эксплуатационными нагрузками, например: гостиницы, школы, больницы. Также рекомендован для использования на путях пожарной эвакуации в общеобразовательных учреждениях: детских садах, школах, гимназиях, а также медицинских клиниках и больницах.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 75 кв.м.\nПроизводитель: Бельгия.\n\nТехнические характеристики:\nОбщая толщина: 2,0 мм.\nТолщина защитного слоя: 0,70 мм.\nКласс покрытия по области применения: 43.\n\nСопутствующие: рулетка, нож, клей Thomsit, клей хол. сварка Sintex H-44, лента малярная, порожки.\n",
        "primaryImageUrl": "//tdp.ru/images/p/9dc/d72dc-b189-11e2-99f1-00259036a114.jpg",
        "assocProducts": "Клей для линолеума холодная сварка",
        "weight": 8600,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 0.33333,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 2081,
        "priceRetailAlt": 693.6597,
        "priceGold": 1998,
        "priceGoldAlt": 665.9934,
        "bonusAmount": 1.25,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 11:46:38"
    },
    {
        "productId": "e85e29d3-a4aa-11e5-bed3-00259036a192",
        "code": "00000153000",
        "title": "Плитка облицовочная 200х300х7 мм Каррара палевая ЛАЙТ (18 шт = 1,08 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\nРисунок на плитку нанесен методом цифровой печати., ее главное отличие отсутствие белого канта по периметру плитки.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nКоличество на поддоне: 80 коробок.\nПроизводитель: ЕВРО-КЕРАМИКА, Россия.\n\nСопутствующие: клей для плитки, клинья для кафеля, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/753/06398-a895-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nклинья для кафеля;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 13300,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "упак.",
        "unitRatioAlt": 1,
        "unitFullAlt": "упаковка",
        "priceRetail": 320,
        "priceRetailAlt": 320,
        "priceGold": 309,
        "priceGoldAlt": 309,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 13:31:48"
    },
    {
        "productId": "af372d06-3ffd-11e5-b9a9-00259036a192",
        "code": "00000146719",
        "title": "Плитка бордюр Bali 400х30х8 мм коричневый",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевая\n\nКоличество в упаковке: 20 шт.\nПроизводитель: GOLDEN TILE, Украина\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/17d/cfe6d-8170-11e5-9d89-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 175,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 130,
        "priceRetailAlt": 130,
        "priceGold": 125,
        "priceGoldAlt": 125,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:41"
    },
    {
        "productId": "e7b7d487-09dc-11e6-bed3-00259036a192",
        "code": "00000156442",
        "title": "Плитка облицовочная 100х300х8 мм Метро красный (21 шт=0,63 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевая\nКоличество на поддоне: 84 коробки\nПроизводитель:.  ШАХТЫ, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/890/02c67-1dd5-11e6-b7ce-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 16924,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 1.5873,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 541,
        "priceRetailAlt": 858.7293,
        "priceGold": 524,
        "priceGoldAlt": 831.7452,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:31:01"
    },
    {
        "productId": "fd21ef21-50c0-11e5-b9a9-00259036a192",
        "code": "00000147224",
        "title": "Плитка облицовочная ЕвроКерамика 200х200х7 мм моноколор желтый (22 шт=0.88 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений. \n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\nСтепень блеска: матовый.\n\nКоличество на поддоне: 104 коробки.\nПроизводитель: ЕВРО-КЕРАМИКА,  Россия.\n\n\nСопутствующие: клей для плитки, крестики , затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/a76/8983c-56d7-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка;\nплиткорез;",
        "weight": 10840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 1.13637,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 349,
        "priceRetailAlt": 396.5931,
        "priceGold": 339,
        "priceGoldAlt": 385.2294,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:18"
    },
    {
        "productId": "89d07661-fb83-11e3-a786-002590c8c920",
        "code": "00000135991",
        "title": "Плитка бордюр Light 200х60 мм зеленый",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество в упаковке: 20 шт.\nПроизводитель:CERSANIT, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/f4a/3f8eb-0369-11e4-a786-002590c8c920.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез.;",
        "weight": 150,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 52,
        "priceRetailAlt": 52,
        "priceGold": 50,
        "priceGoldAlt": 50,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 12:00:32"
    },
    {
        "productId": "178e0743-0d4f-11e6-bed3-00259036a192",
        "code": "00000156845",
        "title": "Керамогранит 298х298х8 мм Амстердам 4 рельеф коричневый  /Керамин (15 шт=1,33206 кв.м)",
        "description": "Предназначена для использования в качестве керамического клинкера для внутренней и наружной облицовки полов, ступеней, фасадов, стен\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевый\nКоличество на поддоне: 50 коробок\nПроизводитель: КЕРАМИН, Беларусь. \nТехнические характеристики:\nКласс износостойкости (PEI): \nМорозостойкость: \n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/6e6/4a5dc-2ee6-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 23100,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.7507,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 619,
        "priceRetailAlt": 464.6833,
        "priceGold": 594,
        "priceGoldAlt": 445.9158,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:06:46"
    },
    {
        "productId": "cded24dc-264c-11e5-b9a9-00259036a192",
        "code": "00000146081",
        "title": "Плитка бордюр Флоренция G 600х90 мм",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: глянцевый.\nКоличество в упаковке: 22 шт.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/d0a/023bd-2ed0-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 872,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 266,
        "priceRetailAlt": 266,
        "priceGold": 259,
        "priceGoldAlt": 259,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:06"
    },
    {
        "productId": "ddf8af34-0d24-11e2-8586-00259036a114",
        "code": "00000125437",
        "title": "Подложка хвойная 7 мм 7 м.кв. Изоплат",
        "description": "Предназначена для использования в качестве теплозвукоизоляционной подложки под паркет или ламинат на твердых и сухих основаниях. Сглаживают неровности, обеспечивают эффективную звукоизоляцию, делают пол более теплым.\n\n\nСостав: 100%  хвойное древесное волокно (без клея и химии).\n\n\nПроизводитель: Эстония.\n\n\nТехнические характеристики: \nРазмер: 850х590х7мм, 14шт./уп., 7 кв.м.\nПлотность: ≥240 кг/м³\nСнижение ударного шума: 22 дБ\nТеплопроводность: 0,05 Вт/(м•К)\n",
        "primaryImageUrl": "//tdp.ru/images/p/280/a5cde-1691-11e2-8586-00259036a114.JPG",
        "assocProducts": "нож;\nлинейка;",
        "weight": 12000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.1429,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1411,
        "priceRetailAlt": 201.6319,
        "priceGold": 1354,
        "priceGoldAlt": 193.4866,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:26:40"
    },
    {
        "productId": "2f5072a8-a7b1-11e5-bed3-00259036a192",
        "code": "00000153154",
        "title": "Ламинат Tarkett Навигатор Колумб 33 кл 12 мм 1.253 кв.м",
        "description": "Предназначен для использования в жилых помещениях с любой проходимостью и в коммерческих помещениях со средней степенью проходимости: гостиные комнаты, коридоры, небольшие офисы, торговые площади небольших магазинов и др.\n\nСостав: Состав: панель ХДФ (древесноволокнистая плита высокой плотности) с усиленной защитой от влаги, декоративный и защитные слои.\n\nРазмер панели: 1294х194х12мм.\nКоличество в упаковке: 5 шт. \nПроизводитель: Россия.\n\nСопутствующие: подложка, рулетка, набор для укладки ламината, лобзик, плинтус, теплый пол под ламинат и паркет.\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/65a/75628-a7b1-11e5-bed3-00259036a192.jpg",
        "assocProducts": "подложка;\nрулетка;\nнабор для укладки ламината;\nлобзик;\nплинтус светлый;\nтеплый пол под ламинат и паркет;",
        "weight": 13000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.79808,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1471,
        "priceRetailAlt": 1173.9757,
        "priceGold": 1428,
        "priceGoldAlt": 1139.6583,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:21:33"
    },
    {
        "productId": "90fddd04-6943-11e2-9939-00259036a114",
        "code": "00000127334",
        "title": "Плитка облицовочная Брава 200х250х7 мм бежевая (20 шт=1 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nКоличество на поддоне: 100 коробок.\nПроизводитель:CERSANIT, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/1b5/577df-6c32-11e2-9939-00259036a114.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 12230,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 1,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 392,
        "priceRetailAlt": 392,
        "priceGold": 379,
        "priceGoldAlt": 379,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 11:41:49"
    },
    {
        "productId": "a46388f8-399e-11df-8e55-0023543d7b52",
        "code": "00000106156",
        "title": "Плитка тротуарная Тучка 300х300х30 мм красная",
        "description": "Предназначена для мощения пешеходных зон, террас, дорожек. \nНа поверхности тротуарной плитки не образуются лужи, так как вода свободно уходит через зазоры, заполненные песком, при необходимости проведения ремонтных работ (например, прокладка подземных коммуникаций) тротуарную плитку можно легко снять, провести необходимые работы и уложить снова, в летнее время нагрев покрытия из плитки значительно меньше, чем нагрев асфальта, при этом плиточное покрытие не размягчается и не выделяет летучих продуктов.\n\nСостав: цемент, песок, химические добавки.\n\nКоличество на поддоне: 144 шт. (Тверь – 165 шт.)\nКоличество в  1м.кв.: 11,1 шт.\nПроизводитель: Россия.\n\nТехнические характеристики:\nПрочность на сжатие, класс: не ниже В 22.5.\nМорозостойкость: F200.\nВодопоглощение по массе: не более 6 %.\n\nСопутствующие: песок строительный, щебень фр.5-20, Мегаизол ГЕО или Наноизол ГЕО, уровень, резиновая киянка, лопата.\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/f89/e7187-b740-11df-9b7f-001f29c68b0a.tif",
        "assocProducts": "песок строительный;\nщебень фр.5-20;\nгеотекстиль;\nуровень;\nрезиновая киянка;\nлопата;",
        "weight": 6000,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 11.1111,
        "unitFullAlt": "",
        "priceRetail": 64,
        "priceRetailAlt": 711.1104,
        "priceGold": 62,
        "priceGoldAlt": 688.8882,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:25:26"
    },
    {
        "productId": "366565d5-9ca5-11e4-afe4-00259036a192",
        "code": "00000139277",
        "title": "Линолеум полукоммерческий 4 м IVC Texmark Forester 837",
        "description": "Полукоммерческий гетерогенный (многослойный) линолеум  на ТЗИ основе с увеличенной толщиной защитного слоя.\nПредназначен для использования в жилых и общественных помещениях с высокими эксплуатационными нагрузками: коридор и кухня в квартире, а также в магазинах, школах, больших офисах, больницах. Обладает устойчивостью к воздействию мебели на роликовых ножках.  \n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: стеклохолст, поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 90 кв.м.\nПроизводитель: Бельгия.\n\nТехнические характеристики:\nОбщая толщина: 2,8 мм.\nТолщина защитного слоя: 0,40 мм.\nКласс покрытия по области применения: 32.\n\nСопутствующие: рулетка, нож, клей Thomsit, клей хол. сварка Sintex H-44, лента малярная, порожки.\n",
        "primaryImageUrl": "//tdp.ru/images/p/5b7/4d8a0-a6fa-11e4-afe5-00259036a192.jpg",
        "assocProducts": "Клей для линолеума холодная сварка",
        "weight": 8000,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.25,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 2193,
        "priceRetailAlt": 548.25,
        "priceGold": 2106,
        "priceGoldAlt": 526.5,
        "bonusAmount": 1.75,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 12:22:25"
    },
    {
        "productId": "d803b105-2707-11e5-b9a9-00259036a192",
        "code": "00000146166",
        "title": "Плитка бордюр Алтай C 200х33 мм зеленый",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество в коробке: 60 шт.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/820/569d7-7d88-11e5-9d89-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 78,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 45,
        "priceRetailAlt": 45,
        "priceGold": 41,
        "priceGoldAlt": 41,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:13"
    },
    {
        "productId": "cff71dfc-0e14-11e6-bed3-00259036a192",
        "code": "00000156901",
        "title": "Керамогранит 600х600х10 мм серый  Crystal  полированный /Грасаро (4 шт= 1,44 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии. \nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевый\nКоличество на поддоне: 32 упаковки\nПроизводитель: GRASARO, Россия\nТехнические характеристики:\nКласс износостойкости: 3\nМорозостойкость: 150 \n\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/d51/132e9-23ee-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 33000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.6944,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1641.6,
        "priceRetailAlt": 1139.9271,
        "priceGold": 1592.35,
        "priceGoldAlt": 1105.7279,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:50"
    },
    {
        "productId": "14ab6a79-0dba-11e5-b9a9-00259036a192",
        "code": "00000145386",
        "title": "Керамогранит Lasselsberger Ceramics Рустик 199х603х10 мм песочный (7 шт=0.84 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество на поддоне: 64 коробки.\nПроизводитель: Россия.\n\nТехнические характеристики:\nКласс износостойкости (PEI): 4.\nМорозостойкость: не менее F 50.\n\nСопутствующие: специальные клеевые смеси для керамогранита (Крепс усиленный, Вебер.Ветонит Профи, Вебер.Ветонит Ультра Фикс, Флизен, Плитонит В+), крестики для плитки, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/3aa/de099-0dbf-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nКлей для плитки;\n;\n;\nФлизен;\nклей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;;\nкрестики для плитки;\nзатирка для швов;\nплиткорез;",
        "weight": 17500,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 1.19048,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 690,
        "priceRetailAlt": 821.4312,
        "priceGold": 670,
        "priceGoldAlt": 797.6216,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:13"
    },
    {
        "productId": "7df0a275-7a6f-11e2-9939-00259036a114",
        "code": "00000128085",
        "title": "Плитка облицовочная 200х300х7 мм Каррара светло-зеленая (18 шт = 1,08 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nКоличество на поддоне: 80 коробок.\nПроизводитель: ЕВРО-КЕРАМИКА, Россия. \n\nСопутствующие: клей для плитки, клинья для кафеля, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/a1f/7ea70-c11d-11e2-99f1-00259036a114.jpg",
        "assocProducts": "клей для плитки;\nклинья для кафеля;\nкрестики;\nзатирка для швов;\nплиткорез.;",
        "weight": 13300,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 0.92592,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 308,
        "priceRetailAlt": 285.1834,
        "priceGold": 298,
        "priceGoldAlt": 275.9242,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 11:43:36"
    },
    {
        "productId": "f55558e8-a7bf-11e5-bed3-00259036a192",
        "code": "00000153175",
        "title": "Ламинат Loc Floor 45 дуб пепельный однополосный 33 кл 8 мм 1.596 кв.м",
        "description": "Предназначен для использования в жилых помещениях с любой проходимостью и в коммерческих помещениях со средней степенью проходимости: гостиные комнаты, коридоры, небольшие офисы, торговые площади небольших магазинов и др.\n\nСостав: Состав: панель ХДФ (древесноволокнистая плита высокой плотности) с усиленной защитой от влаги, декоративный и защитные слои.\n\nРазмер панели: 1200х190х8мм.\nКоличество в упаковке: 7 шт. \nПроизводитель: Россия.\n\nСопутствующие: подложка, рулетка, набор для укладки ламината, лобзик, плинтус, теплый пол под ламинат и паркет.\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/c8c/1724f-d4bc-11e5-bed3-00259036a192.jpg",
        "assocProducts": "подложка;\nрулетка;\nнабор для укладки ламината;\nлобзик;\nплинтус натуральный;\nтеплый пол под ламинат и паркет;",
        "weight": 12370,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.62657,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1337,
        "priceRetailAlt": 837.7241,
        "priceGold": 1298,
        "priceGoldAlt": 813.2878,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:31:53"
    },
    {
        "productId": "458a8581-26fc-11e5-b9a9-00259036a192",
        "code": "00000146147",
        "title": "Плитка бордюр Agatha С 250х35 мм розовый",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: глянцевый.\nКоличество в упаковке: 58 шт.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/a16/98b25-308d-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 114,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 44,
        "priceRetailAlt": 44,
        "priceGold": 43,
        "priceGoldAlt": 43,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:10"
    },
    {
        "productId": "8dd22355-ece5-11e4-afe5-00259036a192",
        "code": "00000144123",
        "title": "Плитка декор Алтай D 200х300х7 мм кофейная",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество в упаковке: 19 шт.\nПроизводитель: ОAО «ВКЗ», Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n",
        "primaryImageUrl": "//tdp.ru/images/p/d46/34033-fbc3-11e4-afe5-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 680,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 94,
        "priceRetailAlt": 94,
        "priceGold": 91,
        "priceGoldAlt": 91,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:58:25"
    },
    {
        "productId": "3300c71f-270a-11e5-b9a9-00259036a192",
        "code": "00000146169",
        "title": "Плитка облицовочная Vesta 200х300х7 мм темно-бежевый (24 шт=1.44 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \nСтепень блеска: глянцевый.\n\nКоличество на поддоне: 54 коробки.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/a58/7b3c3-e5cb-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 16490,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.69444,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 526,
        "priceRetailAlt": 365.2754,
        "priceGold": 510,
        "priceGoldAlt": 354.1644,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:15"
    },
    {
        "productId": "b4c1c519-fb85-11e3-a786-002590c8c920",
        "code": "00000135993",
        "title": "Плитка декор Light 2 200х300х7 мм светло-бежевый",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество в упаковке: 20 шт.\nПроизводитель:CERSANIT, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/07b/adfcb-036a-11e4-a786-002590c8c920.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 730,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 108,
        "priceRetailAlt": 108,
        "priceGold": 105,
        "priceGoldAlt": 105,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 12:00:32"
    },
    {
        "productId": "d051f4a5-4a78-11e6-95f7-00259036a192",
        "code": "00000159177",
        "title": "Плитка облицовочная 200х300х6,9 мм Маронти светлый (25 шт=1,5 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n \nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевый. \nКоличество на поддоне: 64 коробки.\nПроизводитель: KERAMA MARAZZI, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/063/b423f-4a79-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 18000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.66666,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 765,
        "priceRetailAlt": 509.9949,
        "priceGold": 742.05,
        "priceGoldAlt": 494.6951,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:26:58"
    },
    {
        "productId": "53405292-604a-11e5-b9a9-00259036a192",
        "code": "00000147547",
        "title": "Плитка декор Iberia 200х300х7 мм синяя",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\nСтепень блеска: глянцевый.\n\nКоличество в упаковке: 15 шт.\nПроизводитель: ЕВРО-КЕРАМИКА,  Россия.\n\nСопутствующие: клей для плитки, клинья для кафеля, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/ffb/600f5-6114-11e5-b9a9-00259036a192.png",
        "assocProducts": "клей для плитки;\nклинья для кафеля;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 781,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 73,
        "priceRetailAlt": 73,
        "priceGold": 73,
        "priceGoldAlt": 73,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:20"
    },
    {
        "productId": "dbf505c7-8c76-11e5-bed3-00259036a192",
        "code": "00000149636",
        "title": "Керамогранит Estima Brigantina BG 00 150х600х10 мм светло-бежевый (12 шт=1.05 кв.м)",
        "description": "Предназначена для облицовки пола внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\nСтепень блеска: матовая\n\nПроизводитель: Россия.\n\nСопутствующие: клей для керамогранита, крестики, затирка для швов, плиткорез или болгарка с алмазным кругом, строительный уровень, гладкий и зубчатый шпатели, резиновый шпатель для затирки швов.\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/e96/e8ea5-8c77-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;\nстроительный уровень;\nшпатель зубчатый;\nшпатель для затирания швов;",
        "weight": 26000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.95238,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1279,
        "priceRetailAlt": 1218.094,
        "priceGold": 1242,
        "priceGoldAlt": 1182.856,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 13:13:41"
    },
    {
        "productId": "ddf8af34-0d24-11e2-8586-00259036a114",
        "code": "00000125437",
        "title": "Подложка хвойная 7 мм 7 м.кв. Изоплат",
        "description": "Предназначена для использования в качестве теплозвукоизоляционной подложки под паркет или ламинат на твердых и сухих основаниях. Сглаживают неровности, обеспечивают эффективную звукоизоляцию, делают пол более теплым.\n\n\nСостав: 100%  хвойное древесное волокно (без клея и химии).\n\n\nПроизводитель: Эстония.\n\n\nТехнические характеристики: \nРазмер: 850х590х7мм, 14шт./уп., 7 кв.м.\nПлотность: ≥240 кг/м³\nСнижение ударного шума: 22 дБ\nТеплопроводность: 0,05 Вт/(м•К)\n",
        "primaryImageUrl": "//tdp.ru/images/p/280/a5cde-1691-11e2-8586-00259036a114.JPG",
        "assocProducts": "нож;\nлинейка;",
        "weight": 12000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.1429,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1500,
        "priceRetailAlt": 214.35,
        "priceGold": 1470,
        "priceGoldAlt": 210.063,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:26:40"
    },
    {
        "productId": "c42b1d08-4a74-11e6-95f7-00259036a192",
        "code": "00000159169",
        "title": "Плитка облицовочная 200х300х6,9 мм Вилла Флоридиана светло-бежевый ( 25 шт=1,5 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n \nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: глянцевый.\nКоличество на поддоне: 64 коробки.\nПроизводитель: KERAMA MARAZZI, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/08c/08200-4a75-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 18000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.66666,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 747,
        "priceRetailAlt": 497.995,
        "priceGold": 730,
        "priceGoldAlt": 486.6618,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:52:43"
    },
    {
        "productId": "30d1d58f-959f-11e5-bed3-00259036a192",
        "code": "00000151255",
        "title": "Плитка декор Kerama Marazzi Утренний пейзаж 200х300х6.9 мм велосипед",
        "description": "Предназначена для облицовки стен, внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \nСтепень блеска: глянец.\n\nПроизводитель: Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/61a/9ec6c-959f-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 900,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 182,
        "priceRetailAlt": 182,
        "priceGold": 177,
        "priceGoldAlt": 177,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:01:29"
    },
    {
        "productId": "b38d5752-3ffb-11e5-b9a9-00259036a192",
        "code": "00000146710",
        "title": "Плитка напольная Maryland 400х400х7 мм чёрный (7 шт=1.12 кв.м)",
        "description": "Предназначена для отделки пола в ванной комнате, санузлах, кухне и в других внутренних помещениях.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество на поддоне: 72 коробки.\nПроизводитель: GOLDEN TILE, Украина\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/bee/2a094-8eac-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 19840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.89286,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1290,
        "priceRetailAlt": 1151.7894,
        "priceGold": 1251,
        "priceGoldAlt": 1116.9679,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:41"
    },
    {
        "productId": "41db8265-8c77-11e5-bed3-00259036a192",
        "code": "00000149638",
        "title": "Паркетная доска Polarwood дуб дарк браун лак цвета венге трехполосная 14 мм 3.41 кв.м",
        "description": "Предназначен для использования в жилых помещениях с небольшой проходимостью: гостевые комнаты, детские, спальни, гостиничные номера и др.\n\nДопускается сильный разнотон, сросшиеся сучки, темные полосы.\n\nСостав: состоит из нескольких слоев дерева, где ценным является только верхний слой.\n\nРазмер панели: 2266х188х14 мм.\nКоличество в упаковке: 8 шт. \nПроизводитель: Россия.\n\nСопутствующие: подложка, рулетка, набор для укладки ламината, ножовка 500 мм Bahco Профи, плинтус, гель для стыков ламината Clic Protect.\n",
        "primaryImageUrl": "//tdp.ru/images/p/96f/e2fe5-8c77-11e5-bed3-00259036a192.jpg",
        "assocProducts": "подложка;\nрулетка;\nнабор для укладки ламината;\nножовка по ламинату;\nплинтус темный;\nгель для стыков ламината Clic Protect;",
        "weight": 26000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.29325,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 6972,
        "priceRetailAlt": 2044.539,
        "priceGold": 6693,
        "priceGoldAlt": 1962.7222,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:53:07"
    },
    {
        "productId": "92e2b608-a7ae-11e5-bed3-00259036a192",
        "code": "00000153147",
        "title": "Ламинат Ламинели Сибирь кедр алтайский 33 кл 8 мм 2.13 кв.м",
        "description": "Предназначен для использования в жилых помещениях с любой проходимостью и в коммерческих помещениях со средней степенью проходимости: гостиные комнаты, коридоры, небольшие офисы, торговые площади небольших магазинов и др.\n\nСостав: Состав: панель ХДФ (древесноволокнистая плита высокой плотности) с усиленной защитой от влаги, декоративный и защитные слои.\n\nРазмер панели: 1380х193х8мм.\nКоличество в упаковке: 8 шт. \nПроизводитель: Россия.\n\nСопутствующие: подложка, рулетка, набор для укладки ламината, лобзик, плинтус, теплый пол под ламинат и паркет.\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/c2c/a6208-a7ae-11e5-bed3-00259036a192.jpg",
        "assocProducts": "подложка;\nрулетка;\nнабор для укладки ламината;\nлобзик;\nплинтус темный;\nтеплый пол под ламинат и паркет;",
        "weight": 15000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.46948,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1020,
        "priceRetailAlt": 478.8696,
        "priceGold": 990,
        "priceGoldAlt": 464.7852,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:19:29"
    },
    {
        "productId": "2977e4ce-3ffe-11e5-b9a9-00259036a192",
        "code": "00000146721",
        "title": "Плитка декор Bali №2 250х400х8 мм бежевый",
        "description": "ПАННО СОСТОИТ из 4 позиций:\nПлитка декор 250х400х8 мм Бали №1 бежевый\nПлитка декор 250х400х8 мм Бали №2 бежевый\nПлитка декор 250х400х8 мм Бали №3 бежевый\nПлитка декор 250х400х8 мм Бали №4 бежевый\n\nПредназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: глянцевая\nКоличество в упаковке: 6 шт.\nПроизводитель: GOLDEN TILE, Украина\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/4b6/502ad-8170-11e5-9d89-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 1430,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 406,
        "priceRetailAlt": 406,
        "priceGold": 393,
        "priceGoldAlt": 393,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:43"
    },
    {
        "productId": "342ba1b5-3f47-11e5-b9a9-00259036a192",
        "code": "00000146642",
        "title": "Керамогранит Golden Tile декор Sherwood 150х600х9 мм бежевый",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество в упаковке: 15 шт.\nПроизводитель: GOLDEN TILE, Украина\n\nТехнические характеристики:\nКласс износостойкости (PEI): 3.\nМорозостойкость: не менее F 50.\n\nСопутствующие: клей для керамогранита, крестики, затирка для швов, плиткорез, крестики для плитки, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/353/085d3-8e1a-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;\nкрестики для плитки;\nзатирка для швов;\nплиткорез;",
        "weight": 1823,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 296,
        "priceRetailAlt": 296,
        "priceGold": 287,
        "priceGoldAlt": 287,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:22"
    },
    {
        "productId": "f01833ac-3ffa-11e5-b9a9-00259036a192",
        "code": "00000146708",
        "title": "Плитка облицовочная Maryland 300х600х8 мм белый (8 шт=1.44 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: матовый.\nКоличество на поддоне: 32 упаковки.\nПроизводитель: GOLDEN TILE, Украина\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/714/14934-8ead-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 23000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.69444,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1449,
        "priceRetailAlt": 1006.2436,
        "priceGold": 1406,
        "priceGoldAlt": 976.3827,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:40"
    },
    {
        "productId": "9df15fcc-4de9-11e4-a9cf-002590c8c920",
        "code": "00000137699",
        "title": "Керамогранит Керамин Тинторетто 1-1 500х500х9 мм серый (5 шт = 1.25 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество на поддоне: 30 коробок.\nПроизводитель: КЕРАМИН, Беларусь. \n\nТехнические характеристики:\nКласс износостойкости (PEI): ≥ 2.\nМорозостойкость: не менее F 50.\n\nСопутствующие: специальные клеевые смеси для керамогранита (Крепс усиленный, Вебер.Ветонит Профи, Вебер.Ветонит Ультра Фикс, Флизен, Плитонит В+), крестики для плитки, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/79b/3a0e0-5366-11e4-a9cf-002590c8c920.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;;\n;\n;\nФлизен;\nПлитонит В+);\nкрестики для плитки;\nзатирка;\nплиткорез;",
        "weight": 25350,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.8,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 848.94,
        "priceRetailAlt": 679.152,
        "priceGold": 823,
        "priceGoldAlt": 658.4,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:55:19"
    },
    {
        "productId": "8007d487-6b88-11e6-95f7-00259036a192",
        "code": "00000160548",
        "title": "Ламинат 31 класс EPI Классик Деко дуб гасиенда 2,502 кв.м 6 мм",
        "description": "Предназначен для использования в помещениях с небольшой нагрузкой\n\nСостав: HDF плита.\nРазмеры: ширина – 194 мм.\nДлина – 1290 мм.\nТолщина – 6 мм.\n\nПроизводитель: Россия.\n\nТехнические характеристики: HDF плита, 6/31, замок.\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/3e8/3ace6-7426-11e6-95f7-00259036a192.jpg",
        "assocProducts": "подложка;\nрулетка;\nнабор для укладки ламината;\nножовка по ламинату 500 мм Bahco Профи;\nплинтус;\nгель для стыков ламината Clic Protect;\nтеплый пол комплект Thermomat LP под ламинат и паркет.;",
        "weight": 13500,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.39968,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 728,
        "priceRetailAlt": 290.967,
        "priceGold": 699,
        "priceGoldAlt": 279.3763,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:15:15"
    },
    {
        "productId": "f61c9803-1352-11e5-b9a9-00259036a192",
        "code": "00000145462",
        "title": "Керамогранит Zula 150х600х10 мм коричневое дерево (16 шт= 1.44 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество на поддоне: 48 коробок.\nПроизводитель: Китай.\n\nСопутствующие: клей для керамогранита; крестики; затирка для швов; плиткорез; крестики для плитки; затирка для швов; плиткорез;\n",
        "primaryImageUrl": "//tdp.ru/images/p/7d1/0ef6b-3073-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;\nкрестики для плитки;\nзатирка для швов;\nплиткорез;",
        "weight": 28840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.69444,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 888,
        "priceRetailAlt": 616.6627,
        "priceGold": 888,
        "priceGoldAlt": 616.6627,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-25 11:47:52"
    },
    {
        "productId": "0897183e-3ff2-11e5-b9a9-00259036a192",
        "code": "00000146684",
        "title": "Плитка напольная Бамбук 400х400х8 мм коричневый (7 шт=1.12 кв.м)",
        "description": "Предназначена для отделки пола в ванной комнате, санузлах, кухне и в других внутренних помещениях.\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: матовый.\n\nКоличество на поддоне:72 упаковки.\n Производитель: GOLDEN TILE, Украина \n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/bc8/70675-8eb5-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 19840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.89286,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 990,
        "priceRetailAlt": 883.9314,
        "priceGold": 960,
        "priceGoldAlt": 857.1456,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:34"
    },
    {
        "productId": "a6b0d8df-2700-11e5-b9a9-00259036a192",
        "code": "00000146158",
        "title": "Плитка декор панно Фиджи D 250х350х7 мм (4 шт)",
        "description": "ПАННО СОСТОИТ из 4 плиток.\nПредназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\nСтепень блеска- глянцевый\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nКоличество в коробке: 3 панно.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/681/ee01f-3090-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 4300,
        "unit": "компл",
        "unitFull": "комплект",
        "unitRatio": 1,
        "unitAlt": "компл",
        "unitRatioAlt": 1,
        "unitFullAlt": "комплект",
        "priceRetail": 596,
        "priceRetailAlt": 596,
        "priceGold": 579,
        "priceGoldAlt": 579,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:14"
    },
    {
        "productId": "fb60bd6c-0a1b-11e6-bed3-00259036a192",
        "code": "00000156531",
        "title": "Керамогранит 400х400х9 мм Magma белый/Грасаро (9 шт=1,44 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: матовый \nКоличество на поддоне: 48 коробок\nПроизводитель: GRASARO, Россия\n\n\nТехнические характеристики:\nКласс износостойкости (PEI): 3\nМорозостойкость: 150\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/722/c2a84-0a1c-11e6-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 19440,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.6944,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1294,
        "priceRetailAlt": 898.5536,
        "priceGold": 1255,
        "priceGoldAlt": 871.472,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:05:19"
    },
    {
        "productId": "875625ff-0d5b-11e6-bed3-00259036a192",
        "code": "00000156861",
        "title": "Плитка бордюр 275х30 Примавера 4 ",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: глянцевый\nКоличество в упаковке: 30 шт .\nПроизводитель: КЕРАМИН, Беларусь. \n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/15f/292dd-2ee9-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 190,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 51,
        "priceRetailAlt": 51,
        "priceGold": 49,
        "priceGoldAlt": 49,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:06:53"
    },
    {
        "productId": "d4c63448-3fec-11e5-b9a9-00259036a192",
        "code": "00000146677",
        "title": "Плитка декор Summer Stone Holiday №1 250х400х8 бежевый",
        "description": "ПАННО СОСТОИТ из 4 позиций:\nПлитка декор 250х400х8 Саммер Стоун Холидей №1 бежевый\nПлитка декор 250х400х8 Саммер Стоун Холидей №2 бежевый\nПлитка декор 250х400х8 Саммер Стоун Холидей №3 бежевый\nПлитка декор 250х400х8 Саммер Стоун Холидей №4 бежевый\n\nПредназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: матовый.\nКоличество в упаковке: 6 шт.\nПроизводитель: GOLDEN TILE, Украина\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/63d/9a8a5-a306-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 1430,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 289,
        "priceRetailAlt": 289,
        "priceGold": 279,
        "priceGoldAlt": 279,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:32"
    },
    {
        "productId": "e1f83cc7-a2f1-11e5-bed3-00259036a192",
        "code": "00000152730",
        "title": "Ламинат Quick Step Creo дуб вирджиния коричневый 32 кл 7 мм 1.824 кв.м",
        "description": "Предназначена для использования в качестве напольного покрытия в жилых помещениях.\n\nСостав: панель ХДФ (древесноволокнистая плита высокой плотности), декоративный и защитные слои..\n\nРазмер панели: 1200Х190Х7 мм\nКоличество в упаковке: 8шт.\nПроизводитель: Россия.\n\nСопутствующие: подложка, рулетка, набор для укладки ламината, ножовка по ламинату, плинтус, гель для стыков ламината Clic Protect, теплый пол комплект Thermomat LP под ламинат и паркет.\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/1a6/91705-a2f2-11e5-bed3-00259036a192.jpg",
        "assocProducts": "подложка;\nрулетка;\nнабор для укладки ламината;\nножовка по ламинату;\nплинтус темный;\nгель для стыков ламината Clic Protect;\nтеплый пол комплект Thermomat LP под ламинат и паркет;",
        "weight": 12600,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.54825,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1400,
        "priceRetailAlt": 767.55,
        "priceGold": 1359,
        "priceGoldAlt": 745.0718,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:47:22"
    },
    {
        "productId": "0db63538-3f52-11e5-b9a9-00259036a192",
        "code": "00000146646",
        "title": "Керамогранит Golden Tile Kendal 300х600х9 мм коричневый (8 шт=1.44 кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество на поддоне: 32 коробки.\nПроизводитель: GOLDEN TILE, Украина\n\nТехнические характеристики:\nКласс износостойкости (PEI): 3.\nМорозостойкость: не менее F 50.\n\nСопутствующие: клей для керамогранита, крестики, затирка для швов, плиткорез, крестики для плитки, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/66a/15533-8e1b-11e5-bed3-00259036a192.jpg",
        "assocProducts": "клей для керамогранита; крестики; затирка для швов; плиткорез; крестики для плитки; затирка для швов; плиткорез;",
        "weight": 28530,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.69444,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1474,
        "priceRetailAlt": 1023.6046,
        "priceGold": 1415,
        "priceGoldAlt": 982.6326,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-11-02 17:54:36"
    },
    {
        "productId": "e9808fbb-5192-11e5-b9a9-00259036a192",
        "code": "00000147275",
        "title": "Ламинат 32 кл Kronospan Castello Дуб Меринос 2,22 м.кв. 8 мм",
        "description": "Предназначен для использования в жилых помещениях с любой проходимостью и в коммерческих помещениях со средней степенью проходимости: гостинные комнаты, коридоры, небольшие офисы, торговые площади небольших магазинов и др.\n\nСостав: панель ХДФ (древесноволокнистая плита высокой плотности), декоративный и защитные слои.\n\nРазмер панели: 1285х192х8 мм.\nКоличество в упаковке: 9 шт. \nПроизводитель: Беларусь.\nЗамковая система: TwinClic\n\nСопутствующие: подложка, плинтус, рулетка, набор для укладки ламината, ножовка по ламинату 500 мм Bahco Профи, гель для стыков ламината Clic Protect, теплый пол комплект Thermomat LP под ламинат и паркет.",
        "primaryImageUrl": "//tdp.ru/images/p/7dc/87b3e-52f2-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "подложка;\nплинтус натуральный;\nрулетка;\nнабор для укладки ламината;\nножовка по ламинату;\nгель для стыков ламината Clic Protect;\nтеплый пол комплект Thermomat LP под ламинат и паркет;",
        "weight": 15000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.45045,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 728,
        "priceRetailAlt": 327.9276,
        "priceGold": 728,
        "priceGoldAlt": 327.9276,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:41:17"
    },
    {
        "productId": "d1b98e0d-61c8-11e1-865f-00259036a114",
        "code": "00000106104",
        "title": "Плитка облицовочная 200х300х7 мм Каррара  голубая (18 шт = 1,08 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений. \n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nКоличество на поддоне: 80 коробка.\nПроизводитель: ЕВРО-КЕРАМИКА,  Россия.\n\n\nСопутствующие: клей для плитки, крестики , затирка для швов, плиткорез.\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/d1b/98e1c-61c8-11e1-865f-00259036a114.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 14000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 0.92592,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 314,
        "priceRetailAlt": 290.7389,
        "priceGold": 303,
        "priceGoldAlt": 280.5538,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-24 10:57:01"
    },
    {
        "productId": "7f4b5a45-d911-11e4-afe5-00259036a192",
        "code": "00000142281",
        "title": "Линолеум полукоммерческий 4 м Juteks Respect Vero 3361",
        "description": "Полукоммерческий гетерогенный (многослойный) линолеум.\nПредназначен для использования в общественных помещениях с высокими эксплуатационными нагрузками: в магазинах, школах, больших офисах, больницах. Обладает устойчивостью к воздействию мебели на роликовых ножках. Имеет защитный слой, защищающий покрытие от проникновения грязи внутрь и облегчающий уход за ним.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: стеклохолст, поливинилхлорид (ПВХ).\n\nКоличество в рулоне: 18-27 м/п.\nПроизводитель: Россия.\n\nТехнические характеристики:\nОбщая толщина: 2,2 мм.\nТолщина защитного слоя: 0,4 мм.\nКласс покрытия по области применения: 32.\n\nСопутствующие: рулетка, нож, клей Thomsit, клей хол. сварка Sintex H-44, лента малярная, порожки.\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/9b5/7ac1c-02a7-11e5-afe5-00259036a192.jpg",
        "assocProducts": "рулетка;\nнож;\nклей Thomsit;\nклей для линолеума;\nклей для напольных покрытий;\nлента малярная;\nпорожк;",
        "weight": 3600,
        "unit": "м/п",
        "unitFull": "метр погонный",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.25,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1690,
        "priceRetailAlt": 422.5,
        "priceGold": 1623,
        "priceGoldAlt": 405.75,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:57:55"
    },
    {
        "productId": "7dcc18af-50be-11e5-b9a9-00259036a192",
        "code": "00000147222",
        "title": "Плитка облицовочная ЕвроКерамика 200х200х7 мм моноколор голубой (22 шт=0.88 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений. \n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\nСтепень блеска: матовый.\n\nКоличество на поддоне: 104 коробки.\nПроизводитель: ЕВРО-КЕРАМИКА,  Россия.\n\n\nСопутствующие: клей для плитки, крестики , затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/ddd/9dce0-5800-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка;\nплиткорез;",
        "weight": 10840,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 1.13637,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 339,
        "priceRetailAlt": 385.2294,
        "priceGold": 329,
        "priceGoldAlt": 373.8657,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:27:18"
    },
    {
        "productId": "cccba98a-a7ae-11e5-bed3-00259036a192",
        "code": "00000153148",
        "title": "Ламинат Ламинели Сибирь пихта енисейская 33 кл 8 мм 2.13 кв.м",
        "description": "Предназначен для использования в жилых помещениях с любой проходимостью и в коммерческих помещениях со средней степенью проходимости: гостиные комнаты, коридоры, небольшие офисы, торговые площади небольших магазинов и др.\n\nСостав: Состав: панель ХДФ (древесноволокнистая плита высокой плотности) с усиленной защитой от влаги, декоративный и защитные слои.\n\nРазмер панели: 1380х193х8мм.\nКоличество в упаковке: 8 шт. \nПроизводитель: Россия.\n\nСопутствующие: подложка, рулетка, набор для укладки ламината, лобзик, плинтус, теплый пол под ламинат и паркет.\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/035/bae08-a7af-11e5-bed3-00259036a192.jpg",
        "assocProducts": "подложка;\nрулетка;\nнабор для укладки ламината;\nлобзик;\nплинтус светлый;\nтеплый пол под ламинат и паркет;",
        "weight": 15000,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.46948,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 1020,
        "priceRetailAlt": 478.8696,
        "priceGold": 990,
        "priceGoldAlt": 464.7852,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-30 19:19:29"
    },
    {
        "productId": "02143647-7de4-11e3-b1e6-00259036a114",
        "code": "00000133021",
        "title": "Керамогранит ЕвроКерамика Грес 330х330х8 мм 0208 темно-серый (9 шт=1кв.м)",
        "description": "Предназначен для укладки внутри помещений, в том числе с  высокой проходимостью, а так же для наружных работ, для облицовки фасадов и др. \n\nТон (оттенок) и калибр (точность размеров по длине и ширине) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, кварцевый песок, пигменты.\n\nСтепень блеска: матовый.\nКоличество на поддоне: 68 коробок.\nПроизводитель: ЕВРО-КЕРАМИКА, Россия.\n\nТехнические характеристики:\nМорозостойкость: F 150.\n\nСопутствующие: специальные клеевые смеси для керамогранита (Крепс усиленный, Вебер.Ветонит Профи, Вебер.Ветонит Ультра Фикс, Флизен, Плитонит В+), крестики для плитки, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/b10/93417-8744-11e3-b1e6-00259036a114.jpg",
        "assocProducts": "клей для керамогранита;\nкрестики;\nзатирка для швов;\nплиткорез;;\nкрестики для плитки;\nзатирка для швов;\nплиткорез.;",
        "weight": 17600,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 1,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 383,
        "priceRetailAlt": 383,
        "priceGold": 371,
        "priceGoldAlt": 371,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-28 17:52:15"
    },
    {
        "productId": "f006f063-b857-11e5-bed3-00259036a192",
        "code": "00000153848",
        "title": "Плитка декор 400х270х8 мм Капри темно-коричневый",
        "description": "",
        "primaryImageUrl": "//tdp.ru/images/p/7d6/f5678-1c1b-11e6-b7ce-00259036a192.png",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;\nкрестики;\nзатирка для швов",
        "weight": 1400,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 103,
        "priceRetailAlt": 103,
        "priceGold": 99,
        "priceGoldAlt": 99,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:02:11"
    },
    {
        "productId": "0ce858eb-09f2-11e6-bed3-00259036a192",
        "code": "00000156491",
        "title": "Плитка облицовочная 250х400х8 мм Мурайя бежевый (14 шт=1,4 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений. \n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \n\nСтепень блеска: матовый\nКоличество на поддоне: 54 упаковки \nПроизводитель: ШАХТЫ, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/cd9/e7427-20ec-11e6-95f7-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 18620,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.7142,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 740.6,
        "priceRetailAlt": 528.9365,
        "priceGold": 718,
        "priceGoldAlt": 512.7956,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:04:41"
    },
    {
        "productId": "74eccd17-2701-11e5-b9a9-00259036a192",
        "code": "00000146159",
        "title": "Плитка бордюр Фиджи G 350х75 мм",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: глянцевый.\nКоличество в упаковке: 28 шт.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/87a/b5efd-3090-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 341,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 117,
        "priceRetailAlt": 117,
        "priceGold": 113,
        "priceGoldAlt": 113,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:14"
    },
    {
        "productId": "c74ead38-2641-11e5-b9a9-00259036a192",
        "code": "00000146056",
        "title": "Плитка облицовочная Madison 280х400х8 мм бежевый рельеф (11 шт=1.232 кв.м)",
        "description": "Предназначена для облицовки стен внутри жилых (кухня, ванная комната, туалет и пр.) и коммерческих (магазины, кафе, отели и пр.) помещений.\n\nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты. \nСтепень блеска: глянцевый.\n\nКоличество на поддоне: 48 коробок.\nПроизводитель: ВКЗ, Россия.\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.",
        "primaryImageUrl": "//tdp.ru/images/p/291/e26a7-308f-11e5-b9a9-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 17240,
        "unit": "упак.",
        "unitFull": "упаковка",
        "unitRatio": 1,
        "unitAlt": "м. кв.",
        "unitRatioAlt": 0.81169,
        "unitFullAlt": "метр квадратный",
        "priceRetail": 689,
        "priceRetailAlt": 559.2544,
        "priceGold": 668,
        "priceGoldAlt": 542.2089,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 09:59:04"
    },
    {
        "productId": "503393c8-0a03-11e6-bed3-00259036a192",
        "code": "00000156508",
        "title": "Плитка декор 200х300х6,9 мм Традиция бежевый",
        "description": "Предназначена для использования в качестве декоративного элемента, применение которого позволяет украсить облицовываемую поверхность разнообразными узорами и орнаментами.\n \nТон (оттенок) может отличаться от партии к партии.\n\nСостав: огнеупорная глина, песок, известняк, пигменты.\n\nСтепень блеска: Матовый\nКоличество в упаковке: 20 шт.\nПроизводитель: KERAMA MARAZZI, Россия\n\nСопутствующие: клей для плитки, крестики, затирка для швов, плиткорез.\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",
        "primaryImageUrl": "//tdp.ru/images/p/b9c/d2039-0a03-11e6-bed3-00259036a192.jpg",
        "assocProducts": "клей для плитки;\nкрестики;\nзатирка для швов;\nплиткорез;",
        "weight": 900,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "шт.",
        "unitRatioAlt": 1,
        "unitFullAlt": "штука",
        "priceRetail": 175,
        "priceRetailAlt": 175,
        "priceGold": 169,
        "priceGoldAlt": 169,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-27 10:05:05"
    },
    {
        "productId": "a46388f4-399e-11df-8e55-0023543d7b52",
        "code": "00000106155",
        "title": "Плитка тротуарная Паркет 300х300х30 мм серая",
        "description": "Предназначена для мощения пешеходных зон, террас, дорожек. \nНа поверхности тротуарной плитки не образуются лужи, так как вода свободно уходит через зазоры, заполненные песком, при необходимости проведения ремонтных работ (например, прокладка подземных коммуникаций) тротуарную плитку можно легко снять, провести необходимые работы и уложить снова, в летнее время нагрев покрытия из плитки значительно меньше, чем нагрев асфальта, при этом плиточное покрытие не размягчается и не выделяет летучих продуктов.\n\nСостав: цемент, песок, химические добавки.\n\nКоличество на поддоне: 220 шт. (Тверь – 165 шт.)\nКоличество в  1м.кв.: 11,1 шт.\nПроизводитель: Россия.\n\nТехнические характеристики:\nПрочность на сжатие, класс: не ниже В 22.5.\nМорозостойкость: F200.\nВодопоглощение по массе: не более 6 %.\nДопустимое отклонение геометрических параметров по толщине ±6%\n\nСопутствующие: песок строительный, щебень фр.5-20, Мегаизол ГЕО или Наноизол ГЕО, уровень, резиновая киянка, лопата.\n",
        "primaryImageUrl": "//tdp.ru/images/p/da4/4a45e-b9b7-11df-9b7f-001f29c68b0a.jpg",
        "assocProducts": "песок строительный;\nщебень фр.5-20;\nгеотекстиль;\nуровень;\nрезиновая киянка;\nлопата;",
        "weight": 6000,
        "unit": "шт.",
        "unitFull": "штука",
        "unitRatio": 1,
        "unitAlt": "м.кв.",
        "unitRatioAlt": 11.1111,
        "unitFullAlt": "",
        "priceRetail": 49,
        "priceRetailAlt": 544.4439,
        "priceGold": 47,
        "priceGoldAlt": 522.2217,
        "bonusAmount": 0,
        "hasAlternateUnit": true,
        "isActive": true,
        "modified": "2016-10-31 15:25:26"
    }
],

        };
    },

    async mounted() {
        try {
            const unitData = await fetch(UNIT_DATA_URL);
            this.units = await unitData.json();

        } catch (error) {
            console.log(`mounted() => ${error}`);
        }
    },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
